module.exports = __webpack_public_path__ + "img/8.9792d4aa.jpg";